var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTemplate = function SvgTemplate(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0307 3.00757H13.5345C13.9334 3.00757 14.3159 3.16601 14.5979 3.44803C14.8799 3.73006 15.0384 4.11256 15.0384 4.5114V15.0383C15.0384 15.4371 14.8799 15.8196 14.5979 16.1016C14.3159 16.3837 13.9334 16.5421 13.5345 16.5421H4.51153C4.11268 16.5421 3.73018 16.3837 3.44815 16.1016C3.16613 15.8196 3.00769 15.4371 3.00769 15.0383V4.5114C3.00769 4.11256 3.16613 3.73006 3.44815 3.44803C3.73018 3.16601 4.11268 3.00757 4.51153 3.00757H6.01536",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2787 1.50391H6.76724C6.35197 1.50391 6.01532 1.84055 6.01532 2.25582V3.75966C6.01532 4.17493 6.35197 4.51158 6.76724 4.51158H11.2787C11.694 4.51158 12.0307 4.17493 12.0307 3.75966V2.25582C12.0307 1.84055 11.694 1.50391 11.2787 1.50391Z",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template.a6804f5b.svg";
export { ForwardRef as ReactComponent };